export default "assets/images/icons/calendar-e35e480d.svg";